/*
 * @Author: 辰乐 chenxinyu@cai-inc.com
 * @Date: 2024-03-05 15:07:47
 * @LastEditors: 辰乐 chenxinyu@cai-inc.com
 * @LastEditTime: 2024-03-11 11:41:43
 * @FilePath: /zcy-claim-front/src/routes/HolidaySetting/services/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { query } from 'src/utils/request';

// 查询单位考勤组
export const getLeaveConfigList = data => {
  return query('/zlb/api/office/leave/config/paging', {
    method: 'POST',
    data,
  });
};

// 假期配置保存
export const saveLeaveConfig = data => {
  return query('/zlb/api/office/leave/config/save', {
    method: 'POST',
    data,
  });
};

// 查询假期配置详情
export const getLeaveConfigDetail = params => {
  return query('/zlb/api/office/leave/config/detail', {
    params,
  });
};

// 假期设置删除
export const deleteLeaveConfig = data => {
  return query('/zlb/api/office/leave/config/delete', {
    method: 'POST',
    data,
  });
};

// 检查加班规则是否被使用
export const checkOvertimeConfig = params => {
  return query('/zlb/api/office/leave/overtime-config/check', {
    params,
  });
};
